import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import pages from '../../subscriber/Pages';
import { getArray, getArrayLength } from '../../utils/helpers';

const BlogComments = observer(({ slug, t }) => {
    const blog = pages.blogs.find((b) => b.slug === slug);

    if (!blog) return null;
    const { comments = [] } = blog;

    return (
        <div className="mt-10 space-y-6">
            {getArrayLength(comments) === 0 ? (
                <p className="text-gray-500">{t?.firstComment}</p>
            ) : (
                getArray(comments).map((comment) => (
                    <div key={comment.id}>
                        {/* Top-Level Comment */}
                        <div className="bg-white p-4 border rounded-lg shadow-sm w-11/12">
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm font-semibold text-gray-800">
                                    {comment.name}
                                </span>
                                <span className="text-xs text-gray-500">
                                    {moment(comment.created_at).fromNow()}
                                </span>
                            </div>
                            <p className="text-gray-700">{comment.message}</p>
                        </div>

                        {/* Replies */}
                        {getArrayLength(comment.replies) > 0 && (
                            <div className="mt-4 space-y-4 flex flex-col items-end">
                                {getArray(comment.replies).map((reply) => (
                                    <div
                                        key={reply.id}
                                        className="bg-gray-50 p-4 border rounded-lg shadow w-11/12"
                                    >
                                        <div className="flex justify-between items-center mb-2">
                                            <span className="text-sm font-semibold text-gray-800">
                                                {reply.name}
                                            </span>
                                            <span className="text-xs text-gray-500">
                                                {moment(reply.created_at).fromNow()}
                                            </span>
                                        </div>
                                        <p className="text-gray-700">{reply.message}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))
            )}
        </div>
    );
});


export default BlogComments;